import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FilterEngineV2Component, ToolbarV2Module } from '@iot-platform/iot-platform-ui';
import { MasterViewEngineModule } from '@iot-platform/table-engine';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { ProductsCatalogComponent } from './containers/products-catalog/products-catalog.component';
import { ProductsRoutingModule } from './products-routing.module';
import { ProductsEffects } from './state/effects/products.effects';
import * as fromProducts from './state/reducers';

@NgModule({
  declarations: [ProductsCatalogComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    TranslatePipe,
    ToolbarV2Module,
    MasterViewEngineModule,
    ProductsRoutingModule,
    StoreModule.forFeature(fromProducts.featureKey, fromProducts.reducers),
    EffectsModule.forFeature([ProductsEffects]),
    FilterEngineV2Component
  ]
})
export class ProductsModule {}
